import React from "react";
import { Link } from "react-router-dom";
import "../../English/writeblog/writeblog.css";
import ServiceStore from "../../utils/ServiceStore";
import imgeurl from "../../utils/constant";
import { useHistory } from "react-router-dom";
import { CKEditor } from "ckeditor4-react";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { toast } from "react-toastify";

function WriteBlog() {
  const [datalist, setdatalist] = React.useState([]);
  const [conservationtopiclist, setconservationtopiclist] = React.useState([]);

  const [language, setlanguage] = React.useState("");
  const [image, setImage] = React.useState("");

  const [categoryId, setCategoryId] = React.useState("");
  const [title, settitle] = React.useState("");
  const [subtitle, setsubtitle] = React.useState("");
  const [subtitleError, setSubtitleError] = React.useState("");
  const history = useHistory();
  React.useEffect(() => {
    getAlldataFile();
  }, []);
  const logEvent = (e) => {
    setsubtitle(e.editor.getData());
    setSubtitleError("");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!language) {
      toast.warn("Please select a language..", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!image) {
      toast.warn("Please select an image.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!categoryId) {
      toast.warn("Please select a blog category.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (!title) {
      toast.warn("Please enter a title.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (!subtitle) {
      setSubtitleError("Please enter body text.!!"); // Set the subtitle error message
      return;
    } else {
      setSubtitleError(""); // Clear the subtitle error message if the subtitle is not empty
    }
    const auth = JSON.parse(sessionStorage.getItem("items"));

    const ImageData = new FormData();
    ImageData.append("file", image);
    new ServiceStore()
      .InsertData("writeblogtopic/ImageUpload", ImageData)
      .then((res) => {
        console.log("res: ", res);
        if (res.response.status === 1) {
          const methods = "writeblogtopic/";
          const data = {
            language: language,
            username: auth.name,
            title: title,
            categoryId: categoryId,
            subtitle: subtitle,
            status: "Pending",
            userID: auth._id,
            image: res.response.data.imagename,
          };
          new ServiceStore().InsertData(methods, data).then((res) => {
            toast.success("Your blog request is successfully sent.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            history.push("/English/Blog");
          });
        } else {
          toast.error(
            "Something went wrong, Please try again after some time!",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
      });
  };
  const handleIdChange = (event) => {
    const categoryId = event.target.value;
    // const categoryId = event.target.getAttribute('data-tag');

    setCategoryId(categoryId);
  };
  const getAlldataFile = () => {
    const methods = "/blogcategory/English";
    new ServiceStore().GetAllData(methods).then((res) => {
      setdatalist(res.data);
    });
  };
  const langaugeChange = (event) => {
    const categoryId = event.target.value;
    // const categoryId = event.target.getAttribute('data-tag');

    setlanguage(categoryId);
  };

  const ImagehandleIdChange = (e) => {
    setImage(e.target.files[0]);
  };

  return (
    <div className="container-fluid Btp-body">
      <div className="row">
        <div className="Btp-header">
          <span className="Btp-upload">Write a Blog</span>
          <span className="Btp-cross">
            <Link to="/English/Blog">
              <img src="../../images/crossArr.png" />
            </Link>
          </span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row Btp-row">
            <div className="col-xl-3 col-md-3">
              <div className="form-group input-font">
                <label>
                  Language
                  <select
                    className="form-control input-font"
                    onChange={langaugeChange}
                    required
                  >
                    <option value="">Select Language</option>

                    <option value="english">English</option>
                    <option value="marathi">Marathi</option>
                  </select>
                </label>
              </div>
            </div>

            <div className="col-xl-3 col-md-3">
              <div className="form-group">
                <label>Image</label>
                <input
                  className="form-control input-font"
                  style={{ padding: "18px 55px" }}
                  type="file"
                  onChange={ImagehandleIdChange}
                  required
                />
              </div>
            </div>

            <div className="col-xl-3 col-md-3">
              <div className="form-group">
                <label>
                  Category
                  <select
                    className="form-control input-font"
                    onChange={handleIdChange}
                    required
                  >
                    <option value="">Select Blog Category</option>
                    {datalist.map((item) => (
                      <option
                        key={item._id}
                        value={item._id}
                        data-tag={item._id}
                      >
                        {item.category}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
            <div className="col-xl-4 col-md-4">
              <div className="form-group">
                <label>Title</label>

                <input
                  className="form-control input-font"
                  type="text"
                  name="otp"
                  id="otp"
                  placeholder="Enter Topic Title"
                  required
                  onChange={(e) => settitle(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="Btp-editorheader">Body Text</div>
          <div className="row Btp-row">
            <div className="col-xl-12 col-md-12">
              <div className="form-group input-font">
                <CKEditor
                  style={{ fontSize: "15px" }}
                  onSelectionChange={logEvent}
                  data={subtitle}
                  required
                />
              </div>
              {subtitleError && (
                <div
                  className="error-message"
                  style={{ fontSize: "16px", color: "red" }}
                >
                  {subtitleError}
                </div>
              )}
            </div>
          </div>
          {/* <div className='Btp-editor'>
        <div className='Btp-toolbar'>
        <span className="Btp-para">
                    <button
                      className="btn btn-para  dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                    >
                      Paragraph
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <a href="#">HTML</a>
                      </li>
                      <li>
                        <a href="#">CSS</a>
                      </li>
                      <li>
                        <a href="#">JavaScript</a>
                      </li>
                    </ul>
                  </span>
      <span className='Btp-para2'>
      <span className='Btp-bold'><a>B</a></span>
      <span className='Btp-italic'><a>I</a></span>
      <span className='Btp-underline'><a>U</a></span>
      </span>
      
      <span className='span-display'>
      <span className='Btp-minimize'>
      <a> <img src='../../images/minimize.png' /></a>
    
      </span>
      <span className='Btp-Uppertext'><a>AG</a></span>
      <span className='Btp-Midtext'><a>Ag</a></span>
      <span className='Btp-Lowertext'><a>ag</a></span>
      </span>
      
      <span className='Btp-align'>
      <a> <img src='../../images/align.png' /></a>
      </span>
      <span className='Btp-list'>
      <a> <img src='../../images/list.png' /></a>
      </span>
      <span className='Btp-images'>
      <a> <img src='../../images/Images.png' /></a>
      </span>
      <span className='Btp-link'>
      <a> <img src='../../images/Link.png' /></a>
      </span>
        
        
      
        </div>
        <textarea cols="2" rows="10" id="rules" onChange={(e) => setsubtitle(e.target.value)} ></textarea>
        </div> */}

          <div className="Btp-button">
            {/* <Link to="/English/Gallery">
              <button className="Btp-btn1"> Save</button>
            </Link> */}
            {/* <Link to="#">
            <button className="Btp-btn2" type="submit" >Submit</button>
            </Link> */}
            <input type="submit" value="submit" className="Btp-btn2" />
          </div>
        </form>
      </div>
    </div>
  );
}

export default WriteBlog;
